const PricingSection = () => {
  const plans = [
    {
      name: '日間照顧',
      description: '長照3.0補助適用',
      features: [
        '專業照護服務',
        '營養午餐與點心',
        '健康促進活動',
        '認知訓練課程',
        '社交互動活動',
        '定期健康評估',
        '個別化訓練',
        '日常生活訓練',
        '自立支援',
      ],
      highlight: true,
    },
  ];

  const additionalServices = [
    {
      name: '沐浴服務',
      price: '200元/次',
      priceValue: 200,
      icon: 'ri-drop-line',
    },
    {
      name: '交通接送',
      price: '115元/趟',
      priceValue: 115,
      icon: 'ri-bus-line',
    },
  ];

  // 收費標準資料 - 依照圖片格式
  const pricingData = [
    {
      level: '第2級',
      dailyFee: 675,
      midLowSelfPay: 33,
      generalSelfPay: 108
    },
    {
      level: '第3級',
      dailyFee: 840,
      midLowSelfPay: 42,
      generalSelfPay: 134
    },
    {
      level: '第4級',
      dailyFee: 920,
      midLowSelfPay: 46,
      generalSelfPay: 147
    },
    {
      level: '第5級',
      dailyFee: 1045,
      midLowSelfPay: 52,
      generalSelfPay: 167
    },
    {
      level: '第6級',
      dailyFee: 1130,
      midLowSelfPay: 56,
      generalSelfPay: 180
    },
    {
      level: '第7級',
      dailyFee: 1210,
      midLowSelfPay: 60,
      generalSelfPay: 193
    },
    {
      level: '第8級',
      dailyFee: 1285,
      midLowSelfPay: 64,
      generalSelfPay: 205
    }
  ];

  // 結構化資料 - 價格方案
  const pricingStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': 'https://前金日間照顧中心/#pricing-service',
    name: '前金日間照顧中心服務方案',
    description: '高雄市前金區日間照顧中心提供專業長照服務，適用長照3.0補助',
    provider: {
      '@type': 'LocalBusiness',
      name: '前金日間照顧中心',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '自強二路28號',
        addressLocality: '前金區',
        addressRegion: '高雄市',
        postalCode: '801',
        addressCountry: 'TW',
      },
    },
    areaServed: {
      '@type': 'City',
      name: '高雄市',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: '日間照顧服務方案',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '日間照顧服務',
            description: '專業照護服務、營養午餐與點心、健康促進活動、認知訓練課程、社交互動活動、定期健康評估、個別化訓練、日常生活訓練、自立支援',
          },
          priceSpecification: {
            '@type': 'PriceSpecification',
            priceCurrency: 'TWD',
            description: '長照3.0補助適用，一般戶政府補助84%、中低收入戶補助95%、低收入戶全額補助',
          },
          eligibleCustomerType: '65歲以上長者或失能者',
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '沐浴服務',
            description: '專業沐浴照護服務',
          },
          priceSpecification: {
            '@type': 'UnitPriceSpecification',
            price: 200,
            priceCurrency: 'TWD',
            unitText: '次',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '交通接送服務',
            description: '安全舒適的長者交通接送',
          },
          priceSpecification: {
            '@type': 'UnitPriceSpecification',
            price: 115,
            priceCurrency: 'TWD',
            unitText: '趟',
          },
        },
      ],
    },
  };

  // 結構化資料 - 補助資訊表格
  const subsidyTableStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Table',
    about: '長照3.0補助額度說明',
    description: '依據身份別，政府提供不同比例的長照補助：一般戶84%、中低收入戶95%、低收入戶100%全額補助',
  };

  return (
    <section id="pricing" className="py-24 bg-gradient-to-b from-amber-50/30 to-white" aria-labelledby="pricing-title">
      {/* 結構化資料 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pricingStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(subsidyTableStructuredData) }}
      />
      
      <div className="max-w-7xl mx-auto px-6">
        <header className="text-center mb-16">
          <h2 id="pricing-title" className="text-4xl font-bold text-baby-blue-600 mb-4">
            <a href="#pricing" className="hover:text-baby-blue-700 transition-colors">收費標準</a>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            <strong>前金日間照顧中心</strong>提供透明合理的收費標準，並協助申請<strong>長照3.0補助</strong>
          </p>
        </header>

        {/* 收費標準表格 - 依照圖片格式 */}
        <div className="mb-12">
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-baby-blue-100">
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="w-10 h-10 flex items-center justify-center bg-baby-blue-100 rounded-xl">
                <i className="ri-price-tag-3-line text-baby-blue-600 text-xl" aria-hidden="true"></i>
              </div>
              <h3 className="text-2xl font-bold text-baby-blue-600">收費標準</h3>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr>
                    <th className="border-2 border-baby-blue-300 bg-baby-blue-100 px-6 py-4 text-center text-base font-bold text-baby-blue-700"></th>
                    <th className="border-2 border-baby-blue-300 bg-baby-blue-100 px-6 py-4 text-center text-base font-bold text-baby-blue-700">每日費用</th>
                    <th className="border-2 border-baby-blue-300 bg-baby-blue-100 px-6 py-4 text-center text-base font-bold text-baby-blue-700">
                      中低收入戶<br/>
                      <span className="text-cream-600 text-lg">自付額 5%</span>
                    </th>
                    <th className="border-2 border-baby-blue-300 bg-baby-blue-100 px-6 py-4 text-center text-base font-bold text-baby-blue-700">
                      一般戶<br/>
                      <span className="text-cream-600 text-lg">自付額 16%</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {pricingData.map((item, index) => (
                    <tr
                      key={index}
                      className={`transition-transform duration-200 hover:scale-[1.02] hover:shadow-md cursor-default ${
                        index % 2 === 0 ? 'bg-white' : 'bg-baby-blue-50/40'
                      }`}
                    >
                      <td className="border-2 border-baby-blue-300 px-6 py-4 text-center font-bold text-baby-blue-700 text-lg bg-baby-blue-50">
                        {item.level}
                      </td>
                      <td className="border-2 border-baby-blue-300 px-6 py-4 text-center">
                        <span className="font-bold text-baby-blue-600 text-xl">
                          {item.dailyFee.toLocaleString()} 元
                        </span>
                      </td>
                      <td className="border-2 border-baby-blue-300 px-6 py-4 text-center">
                        <span className="font-bold text-cream-600 text-xl">
                          {item.midLowSelfPay} 元
                        </span>
                      </td>
                      <td className="border-2 border-baby-blue-300 px-6 py-4 text-center">
                        <span className="font-bold text-cream-600 text-xl">
                          {item.generalSelfPay} 元
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-6 flex items-start gap-3 bg-cream-50 rounded-xl p-4 border-l-4 border-cream-400">
              <i className="ri-heart-3-fill text-cream-500 text-xl mt-0.5" aria-hidden="true"></i>
              <p className="text-sm text-gray-700">
                <strong className="text-cream-600">低收入戶全額補助</strong> - 符合低收入戶資格者，政府提供100%補助，無需自付費用
              </p>
            </div>
          </div>
        </div>

        {/* 主要方案 */}
        <div className="grid md:grid-cols-1 gap-8 max-w-2xl mx-auto mb-12">
          {plans.map((plan, index) => (
            <article
              key={index}
              className={`bg-white rounded-3xl p-8 shadow-lg ${
                plan.highlight ? 'ring-2 ring-baby-blue-400' : ''
              }`}
            >
              {plan.highlight && (
                <div className="inline-flex items-center gap-2 bg-baby-blue-100 px-4 py-2 rounded-full mb-6">
                  <i className="ri-star-fill text-baby-blue-500" aria-hidden="true"></i>
                  <span className="text-sm font-semibold text-baby-blue-600">推薦方案</span>
                </div>
              )}

              <h3 className="text-2xl font-bold text-baby-blue-600 mb-2">{plan.name}</h3>
              <p className="text-gray-500 mb-6">{plan.description}</p>

              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <i className="ri-checkbox-circle-fill text-cream-500" aria-hidden="true"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#visit"
                className="block w-full text-center py-3 bg-baby-blue-600 text-white rounded-xl font-semibold hover:bg-baby-blue-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                立即諮詢
              </a>
            </article>
          ))}
        </div>

        {/* 自費項目 */}
        <div className="max-w-2xl mx-auto mb-12">
          <h3 className="text-2xl font-bold text-baby-blue-600 mb-6 text-center">自費項目</h3>
          <div className="grid md:grid-cols-2 gap-6">
            {additionalServices.map((service, index) => (
              <article
                key={index}
                className="bg-gradient-to-br from-cream-50 to-baby-blue-50 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-baby-blue-100 rounded-xl">
                    <i className={`${service.icon} text-baby-blue-600 text-xl`} aria-hidden="true"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-baby-blue-600 mb-1">{service.name}</h4>
                    <p className="text-2xl font-bold text-cream-600">{service.price}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* 1966 申請專線 */}
        <div className="max-w-3xl mx-auto mb-12">
          <div className="text-center">
            <a
              href="tel:1966"
              className="inline-flex items-center gap-4 bg-gradient-to-r from-rose-500 to-rose-600 text-white px-10 py-5 rounded-2xl shadow-lg hover:shadow-xl hover:from-rose-600 hover:to-rose-700 transition-all transform hover:scale-105 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full">
                <i className="ri-phone-fill text-3xl" aria-hidden="true"></i>
              </div>
              <div className="text-left">
                <div className="text-lg font-medium opacity-90">長照服務申請專線</div>
                <div className="text-4xl font-bold tracking-wider">1966</div>
              </div>
            </a>
            <p className="mt-4 text-gray-500 text-sm">
              撥打 1966 免費專線，由專人協助您申請長照服務
            </p>
          </div>
        </div>

        {/* 補助說明 */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-baby-blue-50 px-6 py-3 rounded-full">
            <i className="ri-information-line text-baby-blue-500" aria-hidden="true"></i>
            <span className="text-sm text-gray-600">
              符合資格者可申請<strong className="text-baby-blue-600">長照3.0補助</strong>，最高補助95%
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
